import React, { useState, useEffect } from "react";
import classes from "./styles.module.css"; 
import { useNavigate, useParams } from "react-router-dom";
import APIConfig from "../../../../api/APIConfig";
import { Link } from "react-router-dom"
import AuthService from "../../../../services/auth.service";

import {
    Box,
    Center,
    Text,
    Button,
    VStack,
    useColorModeValue,
    StackDivider,
    HStack,
} from '@chakra-ui/react';

function ProfilMentor() {
    let navigate = useNavigate();
    const [namaMentor, setNamaMentor] = useState('');
    const [namaPerusahaan, setNamaPerusahaan] = useState('');

    const [currentUser, setCurrentUser] = useState([]);

    useEffect(() => {
        const user = AuthService.getCurrentUser();
    
        if (user) {
            setCurrentUser(user);
        }
    }, [])

    const getPesertaById = async() => {
        const response = await APIConfig.get(`/v1/mentor/${id}`);
        const data = await response.data
        setNamaMentor(data.namaMentor);
        setNamaPerusahaan(data.namaPerusahaan);

        console.log(data);
    };

    const { id } = useParams();

    useEffect(() => {
        getPesertaById();
        
    });

    return (
        <div className="container">
            <div>
            <Center py={6} marginRight={12}>
            <VStack align='stretch' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'3xl'}>
                Profil
            </Text>
            <HStack color={'gray.500'} pb={10}>
                 <Link to={`/mitra/profile/mentor/list-mentor/${id}`}> Tambah Mentor </Link>
            </HStack>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack 
                divider={<StackDivider borderColor='gray.200' />}
                spacing={4}
                align='stretch'
                >
                <div>
                    <h3 className={classes.h} >Nama Lengkap</h3>
                    <p className={classes.p}>{namaMentor}</p>
                </div>

                <div>
                    <h3 className={classes.h}>Alamat Email</h3>
                    <p className={classes.p}>{currentUser.emailUser}</p> 
                </div>

                <div>
                    <h3 className={classes.h}>Perusahaan</h3>
                    <p className={classes.p}>{namaPerusahaan}</p>
                </div>
                </VStack>
                <Center pt={6}>
                    <Button 
                        onClick={() => navigate(`/mentor/profile/isi-profil/${id}`)}
                        p={6} w='30%' rounded={'xl'} colorScheme='purple' variant='solid'>
                        Edit Profil
                    </Button>
                </Center>
            </Box>
        </VStack>
        </Center>
    </div>
    </div>
    );
}

export default ProfilMentor;
